<template>
  <div class="maindiv news-wrap">
    <div class="list-bg news-bg"></div>
    <div class="discs list htmldiv">
      <div class="cont pt50 pl15">
        <img src="../../assets/images/development.jpg"/>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "development",
}
</script>

<style scoped>
  .news-bg{background: url(../../assets/images/index_05_01.jpg) no-repeat center top;}
  .discs{marign-left: 11px;}
  .discs .cont{text-align: center;}
</style>



// WEBPACK FOOTER //
// src/pages/index/development.vue